<template>
  <div class="customer">
    <div class="customerSearch">
      <div class="search-left">
        <el-input
          size="mini"
          v-model="formInline.queryCustomer"
          placeholder="昵称/手机号/卡号"
          @blur="onInputBlur"
          @clear="onInputBlur"
          clearable
          style="width: 190px;margin-right: 10px"
        >
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-date-picker
          v-model="formInline.dateCustomer"
          size="mini"
          :editable="false"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="~"
          start-placeholder="添加日期"
          end-placeholder="添加日期"
          @change="selectTime"
          style="width:240px;margin-right:10px"
        >
        </el-date-picker>
        <el-select
          v-model="formInline.bindStatus"
          placeholder="请选择"
          size="mini"
          @change="selectBindStatus"
          style="width: 150px"
        >
          <el-option
            v-for="item in options"
            :key="item.bindStatus"
            :label="item.label"
            :value="item.bindStatus"
          >
          </el-option>
        </el-select>
      </div>
      <div class="search-right">
        <el-button
          type="primary"
          plain
          size="mini"
          @click="showApproveLogDialog"
          >档案审批记录</el-button
        >
        <el-button
          v-if="exportOption"
          type="primary"
          size="mini"
          @click="handleExport"
          >导出</el-button
        >
      </div>
    </div>
    <el-row :gutter="20">
      <el-col>
        <el-table
          size="small"
          :data="tableData"
          fit
          highlight-current-row
          align="center"
          :header-cell-style="{ background: '#F9F9F9' }"
          style="font-size: 13px"
          :height="tableHeight"
          ref="eamcTable"
          @sort-change="sortChange"
        >
          <el-table-column prop="customerName" label="客户" min-width="310px">
            <template slot-scope="scope">
              <div>
                <el-row :gutter="20">
                  <el-col :span="30" style="padding:0">
                    <el-avatar
                      size="medium"
                      shape="square"
                      :src="scope.row.avatar"
                      v-image-preview
                    ></el-avatar>
                  </el-col>
                  <el-col :span="70">
                    <div style="color: black" v-if="scope.row.ctmName != null">
                      {{ scope.row.ctmName }}
                    </div>
                    <div style="color: black" v-else>无绑定职称</div>
                    <div style="color: #a09f9fc9; font-size: 12px;">
                      {{ scope.row.name
                      }}<span
                        style="color: rgb(70, 189, 10)"
                        v-if="scope.row.type == 1"
                      >
                        @微信</span
                      ><span style="color: rgb(8, 168, 231)" v-else>
                        @{{ scope.row.corpName }}</span
                      >
                    </div>
                  </el-col>
                </el-row>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="bindStatus" label="绑定状态" min-width="120px">
            <template slot-scope="scope">
              <el-tag type="success" size="medium" v-if="scope.row.bindStatus"
                >已绑定</el-tag
              >
              <el-tag type="danger" size="medium" v-else>未绑定</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="ctmNumb" label="档案数" min-width="100px">
            <template slot-scope="scope">
              <div
                class="ctm-numb-wrap"
                v-if="scope.row.ctmNumb"
                @click="fileDetaiDialogShow(scope.row)"
              >
                <span class="ctm-numb">{{ scope.row.ctmNumb }}</span>
                <i class="el-icon-view"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="consultant" label="所属顾问" min-width="150px">
          </el-table-column>
          <el-table-column prop="ctmCode" label="卡号" min-width="150px">
          </el-table-column>
          <el-table-column prop="ctmTelephone" label="电话" min-width="150px">
          </el-table-column>
          <el-table-column prop="tag" label="客户标签" min-width="250px" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.tag.length > 0">
                <span
                  v-if="scope.row.tag.length == 1 && scope.row.tag[0] == ''"
                >
                  <el-tag size="mini" type="info">暂无标签</el-tag>
                </span>
                <span v-for="item in scope.row.tag" :key="item">
                  <el-tag size="mini" v-if="item != '' && item != null">{{
                    item
                  }}</el-tag>
                </span>
              </div>
              <div v-else>
                <span>
                  <el-tag size="mini" type="info">暂无标签</el-tag>
                </span>
              </div>
            </template>
          </el-table-column>
           <el-table-column
           align="center"
            prop="followUser"
            min-width="200px"
            show-overflow-tooltip
          >
            <template #header>
              跟进人
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="当前添加客户的员工"
                  placement="top-start"
                >
                 <i class="el-icon-question icon-style"></i>
                </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="chargePerson"
            min-width="100px"
            show-overflow-tooltip
          >
            <template #header>
              添加人
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="首次添加客户的员工"
                  placement="top-start"
                >
                  <i class="el-icon-question icon-style"></i>
                </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span style="color: #FFAA33" v-if="!scope.row.addUserName"
                >无添加人</span
              >
              <span v-else>{{ scope.row.addUserName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="添加时间"
            min-width="180px"
            sortable="custom"
          >
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <Pagination
      v-bind:childMsg="pageparm"
      :pageSizes="pageSizes"
      @callBack="callBack"
    ></Pagination>
    <FileApproveLog :visiable="approveLogDialog" @closeLog="closeLog" />
    <!-- 档案详情 -->
    <AllFileDetail
      :visiAble="fileDetaiDialog"
      :detailItem="detailParams"
      @closeDetail="closeDetail"
    ></AllFileDetail>
  </div>
</template>
<script>
// import { getData, getUser, dump, getCustomer, getQwCustomer, getQwAndYuanNeiCustomer } from "../../api/index"
import FileApproveLog from "@/views/customer/components/fileApproveLog.vue";
import AllFileDetail from "@/views/customer/components/allFileDetail.vue";
import {
  getQwAndYuanNeiCustomer,
  synchWeCustomer,
  saveLog,
} from "../../api/customer/customer.js";
export default {
  name: "Eamc",
  components: {
    FileApproveLog,
    AllFileDetail,
  },
  data() {
    return {
      approveLogDialog: false,
      fileDetaiDialog: false,
      detailParams: {},
      tableHeight: 500, //表格距离浏览器底部距离，初始为200
      tableData: [],
      msg: "",
      inputContent: "",
      options: [
        {
          bindStatus: 10,
          label: "不限",
        },
        {
          bindStatus: 1,
          label: "已绑定",
        },
        {
          bindStatus: 0,
          label: "未绑定",
        },
      ],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 200,
      },
      formInline: {
        currentPage: 1,
        pageSize: 20,
        dateCustomer: [],
        bindStatus: 10,
        sortCreateTime: "",
        queryCustomer: "",
        // varLable: '',
        // varName: '',
        // token: localStorage.getItem('logintoken')
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      exportOption: false, // 导出按钮
    };
  },
  created() {
    this.getQwAndYuanNeiCustomerData(this.formInline);
  },
  watch: {
    btnAuthority: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            if (item.pname == "企微客户") {
              let senBtnAuthority = item.cfunBu;
              if (senBtnAuthority.indexOf("khgldc") != -1) {
                // 可导出
                this.exportOption = true;
              } else {
                this.exportOption = false;
              }
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
    "$route.query": {
      handler(oldVal, newVal) {
        console.log("监听路由--9", oldVal);
        if (oldVal && oldVal.dateArr) {
          this.formInline.startTime = oldVal.dateArr[0];
          this.formInline.endTime = oldVal.dateArr[1];
          this.formInline.dateCustomer = oldVal.dateArr;
        }
      },
      deep: true,
      immediate: true,
    },
  },

  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority;
    },
  },
  methods: {
    // 导出
    handleExport() {
      let obj = {
        dateCustomer: this.formInline.dateCustomer, //添加日期时间范围（两个）【array】
        bindStatus: this.formInline.bindStatus, //选择绑定状态， 0：未绑定  1：已绑定【int】
        queryCustomer: this.formInline.queryCustomer, //搜索框（昵称/手机号/卡号）【varchar】
      };
      this.download(
        "/api/qywechat/customer/export",
        `客户表_${new Date().getTime()}.xlsx`,
        {
          ...obj,
        },
        localStorage.getItem("Authorization"),
        false
      ).then((res) => {
        saveLog(localStorage.getItem("Authorization"));
      });
    },
    fileDetaiDialogShow(item) {
      this.detailParams = JSON.parse(JSON.stringify(item));
      this.fileDetaiDialog = true;
    },
    showApproveLogDialog() {
      this.approveLogDialog = true;
    },
    // 关闭档案详情
    closeDetail() {
      this.fileDetaiDialog = false;
    },
    // 关闭档案审批记录
    closeLog() {
      this.approveLogDialog = false;
    },
    sortChange(value) {
      this.formInline.sortCreateTime = value.order;
      this.getQwAndYuanNeiCustomerData(this.formInline);
    },
    // testD(){
    //   dump().then();
    // },
    selectBindStatus(value) {
      this.formInline.currentPage = 1;
      this.getQwAndYuanNeiCustomerData(this.formInline);
    },
    onInputBlur() {
      this.formInline.currentPage = 1;
      this.getQwAndYuanNeiCustomerData(this.formInline);
    },
    selectTime() {
      this.formInline.currentPage = 1;
      this.getQwAndYuanNeiCustomerData(this.formInline);
    },
    refresh() {
      this.formInline.currentPage = 1;
      this.getQwAndYuanNeiCustomerData(this.formInline);
    },
    getData() {
      var dateStart = "2021-05";
      var dateEnd = "2021-06";
      const test = {};
      test.dateStart = dateStart;
      test.dateEnd = dateEnd;
    },
    synchWeCustomerClick() {
      this.$confirm("此操作将同步客户数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.msg = this.$message({
            duration: 0,
            message: "后台开始同步客户数据，请稍后关注进度...",
            type: "warning",
            offset: 10,
          });
          this.synchWeCustomerOption();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消同步",
            offset: 10,
          });
        });
    },
    synchWeCustomerOption() {
      synchWeCustomer(localStorage.getItem("Authorization")).then((res) => {
        if (res.error.code == 200) {
          this.msg.close();
          this.$message({
            duration: 5000,
            showClose: true,
            message: res.error.message,
            type: "success",
          });
        }
      });
    },
    getQwAndYuanNeiCustomerData(parameter) {
      getQwAndYuanNeiCustomer(parameter, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            this.tableData = res.data.result;
            this.pageparm.total = res.data.totals;
            this.pageparm.currentPage = this.formInline.currentPage;
            this.pageparm.pageSize = this.formInline.pageSize;
          }
        })
        .catch((err) => {});
    },
    //设置table距离浏览器底部的高度
    controlHeight() {
      this.$nextTick(function() {
        this.tableHeight =
          window.innerHeight - this.$refs.eamcTable.$el.offsetTop - 237;

        // 监听窗口大小变化
        let self = this;
        window.onresize = function() {
          self.tableHeight =
            window.innerHeight - self.$refs.eamcTable.$el.offsetTop - 237;
        };
      });
    },
    // 分页插件事件
    callBack(parm) {
      this.formInline.currentPage = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.getQwAndYuanNeiCustomerData(this.formInline);
    },
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["eamcTable"].doLayout();
    });
  },
  mounted: function() {
    this.controlHeight();
  },
};
</script>
<style lang="scss">
.customer {
  width: 100%;
  height: 100%;
  .customerSearch {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .ctm-numb-wrap {
    cursor: pointer;
    .ctm-numb {
      margin-right: 5px;
    }
  }
}
.vue-directive-image-previewer {
  z-index: 3000 !important;
  .vue-directive-image-previewer-body {
    .vue-directive-image-previewer-img {
      width: auto !important;
      position: absolute;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%);
      color: rgb(8, 168, 231);
      max-width: 80%;
    }
  }
}
.el-icon-question {
  cursor: pointer;
  margin-left: 0px;
}
</style>
